import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/articles";

const PAGE_LINKS = [
  { label: "首页", to: "/" },
  { label: "深度复盘", to: "/insights" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/#faq" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-editorial px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                料
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">看料吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">{siteInfo.slogan}。聚焦文娱与全网热点，提供有依据的深度复盘。</p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                <i className="ri-mail-line text-sm" aria-hidden="true"></i>
              </span>
              <a href={`mailto:${siteInfo.email}`} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                {siteInfo.email}
              </a>
            </div>
          </div>

          <nav aria-label="页面导航">
            <h2 className="font-heading text-sm font-semibold tracking-wide text-foreground-950">站内导航</h2>
            <ul className="mt-4 space-y-2.5">
              {PAGE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="主题分类">
            <h2 className="font-heading text-sm font-semibold tracking-wide text-foreground-950">主题分类</h2>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/insights?category=${cat.slug}`}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className={`${cat.icon} text-secondary-500`} aria-hidden="true"></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-semibold tracking-wide text-foreground-950">内容原则</h2>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                区分事实与推测，标注信息来源方向
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                不做无依据的揣测与人身攻击
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                发现错误公开更正
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-200/60">
        <div className="mx-auto flex max-w-editorial flex-col items-center justify-between gap-2 px-6 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {year} 看料吃瓜 · 保留所有权利</p>
          <p>本站内容仅用于信息梳理与公共讨论，不构成对任何个人的事实认定。</p>
        </div>
      </div>
    </footer>
  );
}